import { isEmpty, identity } from 'ramda'

import Loading from 'app/common/components/Loader'
import EmptyWarn from 'app/common/layouts/EmptyWarn'
import Tile, { TileType } from 'app/common/templates-next/tile-template/tile'

import { getReportTitle, getReportDescription } from './availableReports'
import { ReportFavoritesSwitcher } from '../common/reports/ReportFavoritesSwitcher'

import styles from './ReportsRoot.scss'
import { useCommonReportsEnabled } from './useCommonReportsEnabled'

type Props = {
  createLink?: (reportKey: string) => string
}

const Reports = ({ createLink = identity }: Props) => {
  const { reportsEnabled, loading } = useCommonReportsEnabled()

  const nothing = isEmpty(reportsEnabled)

  if (loading) {
    return <Loading />
  }

  if (nothing) {
    return <EmptyWarn className={styles.emptyWarn}>{'Нет доступных отчетов'}</EmptyWarn>
  }

  return (
    <div className={styles.root}>
      {reportsEnabled.map((reportKey) => {
        return (
          <Tile
            key={reportKey}
            type={TileType.Report}
            link={createLink(reportKey)}
            title={getReportTitle(reportKey)}
            info={getReportDescription(reportKey)}
            linkButtonTitle="Открыть отчет"
            showMoreButton
          >
            <ReportFavoritesSwitcher reportKey={reportKey} />
          </Tile>
        )
      })}
    </div>
  )
}

export default Reports
